import type { Dispatch, SetStateAction } from 'react'

import { createContext, useContext } from 'react'

export type SearchAutocompleteListContextValue = {
  highlightedIndex: number | null
  setHighlightedIndex: Dispatch<SetStateAction<number | null>>
  setPick: (index: number, pick: (() => void) | null) => void
}

export const SearchAutocompleteListContext =
  createContext<SearchAutocompleteListContextValue | null>(null)

export function useSearchAutocompleteList(): SearchAutocompleteListContextValue | null {
  return useContext(SearchAutocompleteListContext)
}
